// Порядок продуктов в рельсе — пользовательский, временно на клиенте (см. lib/railOrder.ts).
import { useCallback, useEffect, useState } from "react";
import { loadRailOrderCached, fetchRailOrder, saveRailOrder } from "../lib/railOrder";
export function useRailOrder(userId) {
    const [railOrder, setRailOrder] = useState([]);
    // Кеш — мгновенно (первый рендер), сервер — источник истины (перезаписывает, когда ответит);
    // недоступный сервер оставляет кеш/порядок по умолчанию, оболочка не падает (fetchRailOrder).
    useEffect(() => {
        if (!userId)
            return;
        setRailOrder(loadRailOrderCached(userId));
        let cancelled = false;
        fetchRailOrder(userId).then((ids) => {
            if (!cancelled && ids.length)
                setRailOrder(ids);
        });
        return () => { cancelled = true; };
    }, [userId]);
    const onReorderProducts = useCallback((ids) => {
        setRailOrder(ids);
        saveRailOrder(userId, ids);
    }, [userId]);
    return { railOrder, onReorderProducts };
}
